import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoadingComponent} from "@shared/components/loading/loading.component";
import {AuthCallbackComponent} from '@core/auth-callback.component';

const routes: Routes = [
  {path: '', redirectTo: '/dashboard', pathMatch: 'full'},
  {path: 'callback', component: AuthCallbackComponent},
  {path: 'articles', loadChildren: () => import('./article/article.module').then(m => m.ArticleModule)},
  {path: 'contracts', loadChildren: () => import('./contract/contract.module').then(m => m.ContractModule)},
  {path: 'dashboard', loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)},
  {
    path: 'finance-report',
    loadChildren: () => import('./finance-report/finance-report.module').then(m => m.FinanceReportModule)
  },
  {path: 'invoices', loadChildren: () => import('./invoice/invoice.module').then(m => m.InvoiceModule)},
  {path: 'payments', loadChildren: () => import('./payment/payment.module').then(m => m.PaymentModule)},
  {path: 'quotations', loadChildren: () => import('@app/quotation/quotation.module').then(m => m.QuotationModule)},
  {path: 'purchases', loadChildren: () => import('./purchase/purchase.module').then(m => m.PurchaseModule)},
  {path: 'relations', loadChildren: () => import('./relation/relation.module').then(m => m.RelationModule)},
  {
    path: 'relationarticlegroups',
    loadChildren: () => import('./relation/relation-article-group.module').then(m => m.RelationArticleGroupModule)
  },
  {
    path: 'relationgroups',
    loadChildren: () => import('./relation/relation-group.module').then(m => m.RelationGroupModule)
  },
  {path: 'reports', loadChildren: () => import('./reports/report.module').then(m => m.ReportModule)},
  {path: 'stock/vehicles', loadChildren: () => import('./stock/stock.module').then(m => m.StockModule)},
  {
    path: 'stock/vehicle-groups',
    loadChildren: () => import('./stock/stock-group.module').then(m => m.StockGroupModule)
  },
  {path: 'vehicles', loadChildren: () => import('./vehicle/vehicle.module').then(m => m.VehicleModule)},
  {path: 'admin', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)},
  {path: 'work-orders', loadChildren: () => import('@app/work-order/work-order.module').then(m => m.WorkOrderModule)},
  {
    path: 'relation-devices',
    loadChildren: () => import('@app/relation-device/relation-device.module').then(m => m.RelationDeviceModule)
  },
  {path: 'devices', loadChildren: () => import('./device/device.module').then(m => m.DeviceModule)},
  {
    path: 'manufacturers',
    loadChildren: () => import('./manufacturer/manufacturer.module').then(m => m.ManufacturerModule)
  },
  {path: 'settings', loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule)},
  {path: 'loading', component: LoadingComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
